import { wrapDisplayName } from 'recompose'

import { wordpressLanguageSelector } from './selectors'

const propAsKey = propName => WrappedComponent => {
    const component = props => <WrappedComponent {...props} key={props[propName]} />

    component.displayName = wrapDisplayName(WrappedComponent, 'propAsKey')

    return component
}

export const withWordpressLanguage = compose(
    connect(
        createStructuredSelector({
            language: wordpressLanguageSelector,
        })
    ),
    propAsKey('language')
)
